<template>
	<div data-header="green" data-type="layout" id="problems-graph" class="span-full bgwhite black" v-bind:class="{ 'active': isActive }">
		<div class="full-inner">
			<div class="span-table va-top text-left">
				<div class="item">
					<div class="content-500">
						<h3 v-html="consumables.title"></h3>
						<div class="graph-list pt3">
							<div class="field pb1" v-for="item in consumables.stats">
								<span class="label">{{item.title}} {{item.percentage + '%'}}</span>
								<span class="progress">
									<div class="filled" v-bind:style="{ width: (isActive ? parseFloat(item.percentage) + '%' : 0 + '%' ) }"></div>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="item">
					<div class="content-500">
						<h3 v-html="residuals.title"></h3>
						<div class="graph-list pt3">
							<div class="field pb1" v-for="item in residuals.stats">
								<span class="label">{{item.title}} {{item.percentage + '%'}}</span>
								<span class="progress">
									<div class="filled" v-bind:style="{ width: (isActive ? item.percentage + '%' : 0 + '%' ) }"></div>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<p class="text-center pt3">{{credits}}</p>
    </div>
    <a href="#" data-index="3" class="read-more green">
      <span class="arrow-down"></span>
    </a>
  </div>
</template>
<script>
	import misc from '../js/scripts.js'
	export default {
		name: 'problems-plastickill-graph',
		data(){
			return {
				isActive: false,
				credits: '',
				consumables: {},
				residuals: {}
			}
		},
		methods:{
			fadeLayoutIn(){
				var isVisible = (misc.get_viewport().height - this.$el.getBoundingClientRect().top > 0) ? true : false 
				var part = parseInt(((misc.get_viewport().height - this.$el.getBoundingClientRect().top)*100) / misc.get_viewport().height)
				if( isVisible && part > 60 && !this.$el.classList.contains('active') ){
					this.isActive = true
				}
				if( !isVisible ){ 
					this.isActive = false
					this.$el.classList.remove('active')
				}
			},
      getUrl(){
        if( localStorage.getItem('language') === 'en' ){
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problems-statistics'
        } else {
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problemas-estadisticas&lang=es'
        }
      },
      loadContent(){
        var getUrl = this.getUrl()
        window.removeEventListener('scroll', this.fadeLayoutIn )

        this.axios.get(this.getUrl()).then((response) => {
          
          var page = response.data[0]
          this.consumables = page.acf.graphs[0]
          this.residuals = page.acf.graphs[1]
          this.credits = page.acf.credits
          
          if( this.consumables.title && this.residuals.title ){
            this.$nextTick( () => {
  		        window.addEventListener('scroll', this.fadeLayoutIn )
  		      })
          }
          this.$nextTick(()=>{
            misc.addArrows()
          })
        })
      }
    },
    watch: {
      '$route': 'loadContent'
    },
		mounted(){
      this.$nextTick( () => {
        this.loadContent()
      })
    },
    destroyed(){
      window.removeEventListener('scroll', this.fadeLayoutIn )
    }
	}
</script>
<style lang="stylus">
	green = #409d54
	.progress,
	.filled
		border-radius 10px
	.progress
		display: block
		margin-top: 0.5rem
		position relative
		width 100%
		background #cccccc
		height 0.75rem
		border-radius 10px
		.filled
			transition ease width 1s 100ms
			position absolute
			left 0
			top 0
			background green
			height 100%
</style>


// WEBPACK FOOTER //
// Problems-graph.vue?3a9a9860